module.exports = __webpack_public_path__ + "eb42b07d15d344573a3976e6b4abdad3.svg";